import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1011"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M11.11 10.763c-.735-.891-.788-1.919-.705-3.394-2.358.917-1.809 3.561-1.88 4.364-.593-.501-.705-1.697-.705-1.697-.626.332-.94 1.22-.94 1.94 0 1.741 1.403 3.01 3.091 3.01 1.687 0 3.019-1.269 3.019-3.01 0-1.035-.713-1.377-.626-2.932-1.03.303-1.32 1.173-1.254 1.719z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M14.57 3.689s-6.977-2.06-9.323-2.672a.695.695 0 0 0-.836.497L1.028 14.12a.708.708 0 0 0 .476.847.71.71 0 0 0 .876-.485l1.462-5.45 10.829-4.214a.607.607 0 0 0-.101-1.129z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }